import React from "react";

type MembershipViewAccessModalProps = {
  open: boolean;
  message: string;
  requesting?: boolean;
  onCancel: () => void;
  onRequestAccess: () => void | Promise<void>;
};

const MembershipViewAccessModal: React.FC<MembershipViewAccessModalProps> = ({
  open,
  message,
  requesting = false,
  onCancel,
  onRequestAccess,
}) => {
  if (!open) return null;

  return (
    <div className="mva-overlay" role="presentation">
      <div className="mva-modal" role="dialog" aria-modal="true" aria-labelledby="mva-title">
        <h4 id="mva-title" className="mva-title">
          Request membership access
        </h4>
        <p className="mva-text">{message}</p>
        <div className="mva-actions">
          <button
            type="button"
            className="mva-cancel-btn"
            onClick={onCancel}
            disabled={requesting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="mva-request-btn"
            onClick={() => void onRequestAccess()}
            disabled={requesting}
          >
            {requesting ? "Requesting..." : "Request Access"}
          </button>
        </div>
      </div>

      <style>
        {`
        .mva-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 16px;
        }
        .mva-modal {
          width: min(520px, 100%);
          background: #ffffff;
          border-radius: 14px;
          padding: 28px 28px 22px;
          box-shadow: 0 18px 48px rgba(15, 23, 42, 0.22);
        }
        .mva-title {
          margin: 0 0 10px;
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
        }
        .mva-text {
          margin: 0 0 24px;
          font-size: 15px;
          line-height: 1.55;
          color: #475569;
        }
        .mva-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        .mva-cancel-btn,
        .mva-request-btn {
          min-width: 88px;
          padding: 8px 18px;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
        }
        .mva-cancel-btn {
          background: #fff;
          border: 1px solid #d1d5db;
          color: #0f172a;
        }
        .mva-cancel-btn:hover:not(:disabled) {
          background: #f3f4f6;
        }
        .mva-request-btn {
          background: #2d63eb;
          border: none;
          color: #fff;
        }
        .mva-request-btn:hover:not(:disabled) {
          background: #1f4fd4;
        }
        .mva-cancel-btn:disabled,
        .mva-request-btn:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }
      `}
      </style>
    </div>
  );
};

export default MembershipViewAccessModal;
